import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContainerComponent } from '../../../shared/components/container/container.component';
import { GlobalButtonComponent } from '../../../shared/components/global-button/global-button.component';
import { PictureComponent } from '../../../shared/components/picture/picture.component';

@Component({
  selector: '[patient-resources]',
  imports: [ContainerComponent, PictureComponent, GlobalButtonComponent],
  templateUrl: './patient-resources.html',
  styleUrl: './patient-resources.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    id: 'patient-resources',
  },
})
export class PatientResources { }
